import React from 'react';

const Header: React.FC = () => {
  return (
    <header className="bg-white">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <div className="flex-shrink-0">
            <span className="text-xl font-bold">✲ Untitled UI</span>
          </div>
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-4">
              <a href="#" className="px-3 py-2 text-gray-700">Home</a>
              <a href="#" className="px-3 py-2 text-gray-700">Features</a>
              <a href="#" className="px-3 py-2 text-gray-700">Pricing</a>
              <a href="#" className="px-3 py-2 text-gray-700">Resources</a>
              <a href="#" className="px-3 py-2 text-gray-700">About</a>
            </div>
          </div>
          <div className="flex items-center space-x-4">
            <a href="#" className="text-gray-700">Log in</a>
            <a href="#" className="bg-black text-white px-4 py-2 rounded-lg">Get started</a>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
